import { CompositeLayer, MVTLayer} from "deck.gl"
import { _TerrainExtension as TerrainExtension, DataFilterExtension } from "@deck.gl/extensions"
import { generateUrlGeoserverVector, hideLoading, showLoading } from "../core/utils"
import { get } from "ol/proj";


export class AdministrativeBoundsLayer extends CompositeLayer {
    workspace = "";
    layerName = "";
    is3D = false;
    opacity = 100

    constructor(workspace, layerName, is3D, opacity) {
        super();

        this.workspace = workspace;
        this.layerName = layerName;
        this.is3D = is3D;
        this.opacity = opacity
    }

    // Force update layer and re-render sub layers when viewport changes
    shouldUpdateState({ changeFlags }) {
        return changeFlags.somethingChanged;
    }

    renderLayers() {
        const { zoom } = this.context.viewport;
        const dataSource = generateUrlGeoserverVector(this.workspace, this.layerName)
        function lightenColor([r, g, b], percent) {
            const p = percent / 100;
            const newR = Math.min(255, r + (255 - r) * p);
            const newG = Math.min(255, g + (255 - g) * p);
            const newB = Math.min(255, b + (255 - b) * p);
            return [newR, newG, newB];
        }

        return [
            new MVTLayer({
                id: 'sumatraAdminArea1Hover',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: 0,
                stroked: true,
                filled: true,
                getLineColor: [0, 0, 0, 0],
                getFillColor: [0, 0, 0, 0],
                getFilterValue: d => { return d.properties.level },
                filterRange: [[1, 1]],
                extensions: this.is3D
                    ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                    : [new DataFilterExtension({ filterSize: 1 })],
                terrainDrawMode: this.is3D ? 'offset' : '',
                getLineWidth: 1000.0,
                pickable: true,
                visible: zoom < 7.5
            }),
            new MVTLayer({
                id: 'sumatraAdminArea1',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                uniqueIdProperty: 'GID',
                opacity: this.opacity / 100,
                stroked: true,
                filled: true,
                getLineColor: [255, 121, 91, 100],
                getFillColor: [255, 121, 91, 80],
                getFilterValue: d => { return d.properties.level },
                filterRange: [[1, 1]],
                extensions: this.is3D
                    ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                    : [new DataFilterExtension({ filterSize: 1 })],
                terrainDrawMode: this.is3D ? 'drape' : '',
                getLineWidth: 1000.0,
                pickable: true,
                //autoHighlight: true,
                //highlightColor: [255, 255, 0, 100],
                binary: false,
                visible: zoom < 7.5
            }),

            new MVTLayer({
                id: 'sumatraAdminArea2Hover',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: 0,
                stroked: true,
                filled: true,
                getLineColor: [120, 120, 120],
                getFillColor: [123, 152, 255, 50],
                getFilterValue: d => d.properties.level,
                filterRange: [[2, 2]],
                extensions: this.is3D
                    ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                    : [new DataFilterExtension({ filterSize: 1 })],
                terrainDrawMode: this.is3D ? 'offset' : '',
                getLineWidth: 500 ,
                pickable: true,
                visible: zoom >= 7.5 && zoom < 9.5
            }),
        
            new MVTLayer({
                id: 'sumatraAdminArea2',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                filled: true,
                getLineColor: [123, 152, 255, 100],
                getFillColor:[123, 152, 255, 50],
                getFilterValue: d => d.properties.level,
                filterRange: [[2, 2]],
                extensions: this.is3D
                    ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                    : [new DataFilterExtension({ filterSize: 1 })],
                terrainDrawMode: this.is3D ? 'drape' : '',
                getLineWidth: 500 ,
                pickable: false,
                visible: zoom >= 7.5 && zoom < 9.5
            }),

            new MVTLayer({
                id: 'sumatraAdminArea3Hover',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: 0,
                stroked: true,
                filled: true,
                getLineColor: [123, 216, 255, 100],
                getFillColor: [123, 216, 255, 50],
                getFilterValue: d => d.properties.level,
                filterRange: [[3, 3]],
                extensions: this.is3D
                    ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                    : [new DataFilterExtension({ filterSize: 1 })],
                terrainDrawMode: this.is3D ? 'offset' : '',
                getLineWidth: 100,
                lineWidthMinPixels: 1.0,
                pickable: true,
                visible: zoom >= 9.5 && zoom < 12
            }),

            new MVTLayer({
                id: 'sumatraAdminArea3',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                filled: true,
                getLineColor: [123, 216, 255, 100],
                getFillColor: [123, 216, 255, 50],
                getFilterValue: d => d.properties.level,
                filterRange: [[3, 3]],
                extensions: this.is3D
                    ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                    : [new DataFilterExtension({ filterSize: 1 })],
                terrainDrawMode: this.is3D ? 'drape' : '',
                getLineWidth: 100,
                lineWidthMinPixels: 1.0,
                pickable: false,
                visible: zoom >= 9.5 && zoom < 12
            }),
            
            
            new MVTLayer({
                id: 'sumatraAdminArea4Hover',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: 0,
                stroked: true,
                filled: true,
                getLineColor:[120, 120, 120, 100],
                getFillColor: [120, 120, 120, 50],
                getFilterValue: d => d.properties.level,
                filterRange: [[4, 4]],
                terrainDrawMode: this.is3D ? 'offset' : '',
                extensions: this.is3D
                    ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                    : [new DataFilterExtension({ filterSize: 1 })],
                getLineWidth: 90,
                lineWidthMinPixels: 1.0,
                pickable: true,
                visible: zoom >= 12
            }),

            new MVTLayer({
                id: 'sumatraAdminArea4',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                filled: true,
                getLineColor:[120, 120, 120, 100],
                getFillColor: [120, 120, 120, 50],
                getFilterValue: d => d.properties.level,
                filterRange: [[4, 4]],
                terrainDrawMode: this.is3D ? 'drape' : '',
                extensions: this.is3D
                    ? [new DataFilterExtension({ filterSize: 1 }), new TerrainExtension()]
                    : [new DataFilterExtension({ filterSize: 1 })],
                getLineWidth: 90,
                lineWidthMinPixels: 1.0,
                pickable: false,
                visible: zoom >= 12
            }),
        ]
    }
}
